module.exports = __webpack_public_path__ + "static/media/22.739dac98.png";